module.exports = __webpack_public_path__ + "static/media/Olive-Green_1.49218dc8.jpg";